<template>
  <div>
    <section class="highlights" v-if="misc">
      <div class="inner">
        <div class="left">
          <div :key="feature._id" v-for="feature in misc.features_section">
            <i class="fa fa-check-circle"></i>
            {{ feature.text }}
          </div>
        </div>
      </div>
    </section>

    <div class="inner reviews">
      <div class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="5da447b7ffa5b70001ecfc5b" data-style-height="140px" data-style-width="100%"
        data-theme="light" data-stars="4,5" data-review-languages="en">
        <a href="https://www.trustpilot.com/review/www.wortleybrotherswoodengates.co.uk" target="_blank"
          rel="noopener">Trustpilot</a>
      </div>
    </div>

    <div class="inner">
      <div class="notice" v-if="misc && misc.notice">
        <i class="fa fa-exclamation-circle"></i>
        {{ misc.notice }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Features",
  computed: {
    misc: function () {
      return this.$store.state.misc
    }
  },
  mounted() {
    // Reinitialize the TrustBox widget when the component is mounted
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(this.$el.getElementsByClassName('trustpilot-widget')[0], true);
    }
  }
}
</script>

<style scoped>
.trustpilot-widget {
  font-family: Krub, Geneva, sans-serif;
}

.reviews {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.notice {
  text-align: center;
  border: 1px solid #cc0000;
  background: #cc0000;
  padding: 1rem 2rem;
  font-size: 1.3rem;
  margin-top: 2rem;
  font-family: Arial, Helvetica, sans-serif;
  color: white;
}

.notice .fa {
  margin-right: 0.5rem;
}

.highlights {
  background-color: #f79322;
  clear: both;
  color: #414e4f;
  font-size: 1.6rem;
  text-align: center;
}

.highlights div {
  display: inline-block;
  padding: 0.7rem 1.5rem;
}

.highlights i {
  color: rgba(255, 255, 255, 0.692);
  margin-right: 0.5rem;
}

@media screen and (max-width: 1200px) {
  .highlights div {
    padding: 0.3rem 1.5rem;
  }
}

@media screen and (max-width: 950px) {
  .highlights {
    padding: 0.2rem;
  }

  .highlights .inner {
    display: none;
  }
}
</style>
